/* eslint-disable global-require,import/no-unresolved */
import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import styles, { colors } from '../../styles'
import panelStyles from '../../styles/panel'
import textStyles from '../../styles/text'
import LightButton from './LightButton'
import * as ResourceManager from '../methods/ResourceManager'
import { gotoSubPage } from '../../actions/helpers'

function SendingWavesPage(props) {
  const { t } = props
  return (
    <View style={{ flex: 1 }}>
      <ScrollView
        style={{ backgroundColor: colors.raven_grey10 }}
        testID="scrollview-SendingWaves"
      >
        <View style={styles.container}>
          <View style={textStyles.h1Container}>
            <Text style={[textStyles.blueMediumText]}>{t('howManyYellowSendingTitle')}</Text>
          </View>

          <View style={panelStyles.lightsContainer}>
            <LightButton
              accessibilityLabel={t('access:oneSendingWaveButton')}
              testID="one-sending-wave-btn"
              buttonText={t('common:yellowSendingOneTitle')}
              imageSource={ResourceManager.loadImage('one_sending_wave')}
              imageStyle={{ width: 277, height: 59 }}
              onPressHandler={() => gotoSubPage('OneSendingWavePage', 'oneSending')}
            />
            <LightButton
              accessibilityLabel={t('access:twoSendingWavesButton')}
              testID="two-sending-wave-btn"
              buttonText={t('common:yellowSendingTwoTitle')}
              imageSource={ResourceManager.loadImage('two_sending_waves')}
              imageStyle={{ width: 277, height: 59 }}
              onPressHandler={() => gotoSubPage('TwoSendingWavesPage', 'twoSending')}
            />
            <LightButton
              accessibilityLabel={t('access:threeSendingWavesButton')}
              testID="three-sending-wave-btn"
              buttonText={t('common:yellowSendingThreeTitle')}
              imageSource={ResourceManager.loadImage('three_sending_waves')}
              imageStyle={{ width: 277, height: 59 }}
              onPressHandler={() => gotoSubPage('ThreeSendingWavesPage', 'threeSending')}
            />

          </View>
        </View>
      </ScrollView>
    </View>
  )
}

SendingWavesPage.propTypes = {
  t: PropTypes.func.isRequired,
}

export const SendingWavesPageComponent = SendingWavesPage

export default withTranslation(['indicatorLights', 'common'])(SendingWavesPage)
